import { render } from "./AccountBox.vue?vue&type=template&id=56765bd4&scoped=true"
import script from "./AccountBox.vue?vue&type=script&lang=js"
export * from "./AccountBox.vue?vue&type=script&lang=js"

import "./AccountBox.vue?vue&type=style&index=0&id=56765bd4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56765bd4"]])

export default __exports__